import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { matchPath, useLocation } from 'react-router';

import { LAYOUT_TYPE_IN_POPUP } from '../../constants/lw';
import {
  CHANNEL_VIEW_PATH,
  DEFAULT_VIEW_PATH,
  SEARCH_AI_VIEW_PATH,
  SEARCH_VIEW_PATH,
  SHARE_VIEW_PATH,
  SINGLE_VIEW_PATH,
} from '../../constants/routePath';

import { RootContainers } from '../../helpers';
import { hasPublisherAnchor, offset, scrollYByElement } from '../../helpers/dom';
import * as commonSelectors from '../../redux/selectors/common';

import { ScrollContext } from './ScrollObserverProvider';

function ScrollObserver() {
  const scrollMapData = useContext(ScrollContext);
  const layout = useSelector(commonSelectors.layoutSelector);
  const location = useLocation();
  const offsetTop = useSelector(commonSelectors.offsetTopSelector);

  useEffect(() => {
    if (layout !== LAYOUT_TYPE_IN_POPUP) {
      const toTop = [
        { path: SINGLE_VIEW_PATH },
        { path: DEFAULT_VIEW_PATH },
        { path: SEARCH_VIEW_PATH },
        { path: SEARCH_AI_VIEW_PATH },
        { path: SHARE_VIEW_PATH },
        { path: CHANNEL_VIEW_PATH },
      ].find((route) => matchPath(route, location.pathname));

      if (toTop) {
        scrollYByElement(window, offset(RootContainers.getRootContainer()).top - offsetTop);
      } else if (!hasPublisherAnchor() && !scrollMapData.firstEnter) {
        scrollYByElement(window, scrollMapData.map[location.pathname] ?? 0);
      } else {
        scrollMapData.map[location.pathname] = window.scrollY;
      }

      scrollMapData.firstEnter = false;
    }
  }, [location.pathname, layout]);

  return null;
}

export default ScrollObserver;
